import { render, staticRenderFns } from "./CadastroHotel.vue?vue&type=template&id=26a52073&"
import script from "./CadastroHotel.vue?vue&type=script&lang=js&"
export * from "./CadastroHotel.vue?vue&type=script&lang=js&"
import style0 from "./CadastroHotel.vue?vue&type=style&index=0&soped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports